<template>
  <!-- Diminuir o width desse modal e abrir ele fora de rota -->
  <div
    class="modal fade"
    id="importCsv"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="messageModalStaticBackdropLabel"
    aria-hidden="true"
    ref="uploadCsvFundos"
  >
    <div
      class="modal-dialog modal-custom modal-custom-sm modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="messageModalStaticBackdropLabel">
            Atenção!
          </h1>
          <button
            class="btn-close"
            type="button"
            v-on:click="updateModal"
            aria-label="Fechar"
          ></button>
        </div>
        <div class="modal-body d-flex flex-column align-items-start pb-5 pt-3">
          <!--replace accept, ex: '.csv, .pdf, .png'-->
          <img
            src="@/assets/img/filefiled.svg"
            alt=""
            class="align-self-center py-3"
            srcset=""
          />
          <h3 class="title py-4">
            Falha na importação pelo(s) seguinte(s) motivo(s)
          </h3>

          <ul v-for="(item, key) in arrError" :key="key">
            <li>{{ $translate(item) }}</li>
          </ul>
        </div>
        <!-- <div class="modal-footer">
                   
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "upload-failure",
  components: {},
  props: {
    openModal: Boolean,
    arrError: Array,
  },

  data() {
    return {
      modal: "",
    };
  },
  mounted() {
    this.modal = new Modal(this.$refs.uploadCsvFundos);
    this.modal.show();
  },

  methods: {
    updateModal() {
      this.modal.hide();
      this.$parent.openModalFailure(true);
    },
  },
};
</script>

<style scoped></style>
>
